import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 172539 172541"
    {...props}
  >
    <path
      d="m130277 111163 42262-2588-35716-22750 35312-23374-42307-1842 18893-37897-37560 19555L108572 0 85825 35721 62446 409l-1839 42304-37900-18890 19560 37558L0 63971l35715 22747L406 110095l42305 1842-18893 37898 37563-19558 2585 42264 22752-35713 23374 35310 1842-42305 37898 18888z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
